import { toast } from 'react-toastify';
import { convertPageableResponse } from '../../utils/responseMapper';
import * as api from '../api/notesApi';
import * as types from '../constants/notesConstants';

export const getUserNotesAction = (search) => async (dispatch) => {
  dispatch({ type: types.GET_USER_NOTES_REQUEST });
  try {
    const { error, data } = await api.getUserNotes(search);
    if (error) {
      throw new Error(error);
    }
    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);
    dispatch({
      type: types.GET_USER_NOTES_SUCCESS,
      payload: { data: content, pageable },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити нотатки');
    dispatch({ type: types.GET_USER_NOTES_FAILURE });
  }
};

export const getPublicNotesAction = (search) => async (dispatch) => {
  dispatch({ type: types.GET_PUBLIC_NOTES_REQUEST });
  try {
    const { error, data } = await api.getPublicNotes(search);
    if (error) {
      throw new Error(error);
    }
    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);
    dispatch({
      type: types.GET_PUBLIC_NOTES_SUCCESS,
      payload: { data: content, pageable },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити публічні нотатки');
    dispatch({ type: types.GET_PUBLIC_NOTES_FAILURE });
  }
};

export const getNoteByIdAction = (noteId) => async (dispatch) => {
  dispatch({ type: types.GET_NOTE_REQUEST });
  try {
    const { error, data } = await api.getNoteById(noteId);
    if (error) {
      throw new Error(error);
    }
    dispatch({ type: types.GET_NOTE_SUCCESS, payload: data });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити нотатку');
    dispatch({ type: types.GET_NOTE_FAILURE });
  }
};

export const createNoteAction = (note) => async () => {
  try {
    const { error, data } = await api.createNote(note);
    if (error) {
      throw new Error(error);
    }
    toast.success('Нову нотатку додано');
    return data;
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати нотатку');
    return null;
  }
};

export const updateNoteAction = (noteId, note) => async () => {
  try {
    const { error } = await api.updateNote(noteId, note);
    if (error) {
      throw new Error(error);
    }
    toast.success('Нотатку було змінено');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити нотатку');
  }
};

export const deleteNoteAction = (noteId) => async () => {
  try {
    const { error } = await api.deleteNote(noteId);
    if (error) {
      throw new Error(error);
    }
    toast.success('Нотатку було видалено');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити нотатку');
  }
};

export const toggleNotePublicAction = (noteId, note) => async () => {
  try {
    const { error } = await api.updateNote(noteId, {
      title: note.title,
      content: note.content,
      plainText: note.plainText,
      isPublic: !note.isPublic,
    });
    if (error) {
      throw new Error(error);
    }
    toast.success(note.isPublic ? 'Нотатку зроблено приватною' : 'Нотатку зроблено публічною');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити видимість нотатки');
  }
};

export const setSelectedNoteAction = (note) => async (dispatch) => {
  dispatch({ type: types.SELECT_NOTE, payload: note });
};

export const clearSelectedNoteAction = () => async (dispatch) => {
  dispatch({ type: types.CLEAR_SELECTED_NOTE });
};

export const clearNoteAction = () => async (dispatch) => {
  dispatch({ type: types.CLEAR_NOTE });
};

export const clearUserNotesAction = () => async (dispatch) => {
  dispatch({ type: types.CLEAR_USER_NOTES });
};

export const clearPublicNotesAction = () => async (dispatch) => {
  dispatch({ type: types.CLEAR_PUBLIC_NOTES });
};

// user notes pagination
export const setUserNotesSearchAction = (search) => async (dispatch) => {
  dispatch({ type: types.SET_USER_NOTES_SEARCH, payload: search });
};

export const setUserNotesPageSizeAction = (pageSize) => async (dispatch) => {
  dispatch({ type: types.SET_USER_NOTES_PAGE_SIZE, payload: pageSize });
};

export const nextUserNotesPageAction = () => async (dispatch) => {
  dispatch({ type: types.NEXT_USER_NOTES_PAGE });
};

export const prevUserNotesPageAction = () => async (dispatch) => {
  dispatch({ type: types.PREV_USER_NOTES_PAGE });
};

// public notes pagination
export const setPublicNotesSearchAction = (search) => async (dispatch) => {
  dispatch({ type: types.SET_PUBLIC_NOTES_SEARCH, payload: search });
};

export const setPublicNotesPageSizeAction = (pageSize) => async (dispatch) => {
  dispatch({ type: types.SET_PUBLIC_NOTES_PAGE_SIZE, payload: pageSize });
};

export const nextPublicNotesPageAction = () => async (dispatch) => {
  dispatch({ type: types.NEXT_PUBLIC_NOTES_PAGE });
};

export const prevPublicNotesPageAction = () => async (dispatch) => {
  dispatch({ type: types.PREV_PUBLIC_NOTES_PAGE });
};
